import { render, staticRenderFns } from "./BizGiftCardWriteOff.vue?vue&type=template&id=59aeaa1f&scoped=true&"
import script from "./BizGiftCardWriteOff.vue?vue&type=script&lang=js&"
export * from "./BizGiftCardWriteOff.vue?vue&type=script&lang=js&"
import style0 from "./BizGiftCardWriteOff.vue?vue&type=style&index=0&id=59aeaa1f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59aeaa1f",
  null
  
)

export default component.exports